import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Injectable( {
    providedIn: 'root'
} )
export class SeoService {

    private doc = inject( DOCUMENT );
    private router = inject( Router );

    updateCanonicalUrl( url: string ): void {
        this.clearAlternate();
        let el = this.doc.querySelector<HTMLLinkElement>( "link[rel='canonical']" );
        if ( !el ) {
            el = this.doc.createElement( 'link' );
            this.doc.head.appendChild( el );
        }
        el.setAttribute( 'rel', 'canonical' );
        el.setAttribute( 'href', url );
    }

    clearAlternate(): void {
        this.doc.querySelectorAll<HTMLLinkElement>( "link[rel='alternate']" )
            .forEach( el => el.remove() );
    }

    clearPagination(): void {
        this.doc.querySelectorAll<HTMLLinkElement>( "link[rel='prev'], link[rel='next']" )
            .forEach( el => el.remove() );
    }

    addAlternateUrl( url: string, lang = '', rel = 'alternate' ): void {
        const node = this.doc.createElement( 'link' );
        node.setAttribute( 'rel', rel );
        node.setAttribute( 'href', url );
        if ( lang ) node.setAttribute( 'hreflang', lang );
        this.doc.head.appendChild( node );
    }

    getCurUrlNoPaged(): string {
        return `https://${ this.doc.location.hostname }${ this.router.url }`.split( '?' )[ 0 ];
    }
}